import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import textimage from "./../../../../images/foods/textimage.png";
import multmedi from "./../../../../images/foods/multmedi.png";
import textandmulti from "./../../../../images/foods/textandmulti.png";
import texticon from "./../../../../images/foods/texticon.png";
import mediaicon from "./../../../../images/foods/media.png";
import audioalone from "./../../../../images/foods/audioalone.png";
import audiovideo from "./../../../../images/foods/audiovideo.png";
import template from "./../../../../images/foods/template.png";
import imagefile from "./../../../../images/foods/imagefile.png";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import StepOne from "./StepOne";

const StepFour = (props) => {
  // const [activeToggle, setActiveToggle] = useState("posts");
  // const [replayModal, setReplayModal] = useState(false);
  useEffect(() => {
    console.log("props.StepOne", props);
    // console.log(
    //   "props.campaign_creation",
    //   props.campaign_creation.selected_message_type
    // );
  }, [props]);

  // const handleRadioClick = () => {
  //   setShowInput(!showInput);
  //   setMultiShowInput(false);
  // };

  // const handlemultiClick = () => {
  //   setMultiShowInput(!multishowInput);
  //   setShowInput(false);
  // };
  // const handleInputChange = (e) => {
  //   setUserInput(e.target.value);
  // };

  return (
    <div className="col-xl-12 col-lg-6">
      <h4 className="card-title">User Type </h4>
      <div className="basic-form">
        <form
          onChange={(e) => {
            props.handleChange("message_recipient_type", e.target.value);
          }}
        >
          <div className="form-group mb-0">
            <ul style={{ display: "flex" }}>
              <li style={{ marginLeft: "23%", width: "20%" }}>
                <label className="radio-inline me-3">
                  <input
                    type="radio"
                    name="test"
                    value="1"
                    checked={
                      props.campaign_creation.message_recipient_type == "1"
                        ? true
                        : false
                    }
                  />{" "}
                  <h3 style={{ margin: "5px 24px" }}>Individual</h3>{" "}
                </label>
              </li>

              <li style={{ width: "20%" }}>
                <label className="radio-inline me-3">
                  <input
                    type="radio"
                    name="test"
                    value="2"
                    checked={
                      props.campaign_creation.message_recipient_type == "2"
                        ? true
                        : false
                    }
                  />
                  <h3 style={{ margin: "5px 24px" }}>Multiple</h3>
                </label>
              </li>
            </ul>
          </div>
        </form>
        <br /> <br />
        {props.campaign_creation.message_recipient_type == "1" && (
          <div style={{ marginLeft: "349px" }}>
            <label>
              Enter the User Number
              <input
                className="form-file-input form-control"
                maxlength="10"
                type="number"
                onChange={(e) => {
                  
                  if (e.target.value.length > 10) return false;
                  else if (e.target.value.length < 11)
                    console.log(e.target.value.length);
                  props.handleChange("message_recipient_no", e.target.value);
                }}
              />
            </label>
          </div>
        )}
        {props.campaign_creation.message_recipient_type == "2" && (
          <div className="basic-form form_file_input" style={{ width: "50%" }}>
            <form action="#">
              <div style={{ marginLeft: "349px" }}>
                <div className="form-file">
                  <label>
                    File Upload
                    <input
                      type="file"
                      onChange={(e) => {
                        props.handleChange(
                          "message_recipient_file",
                          e.target.value
                        );
                      }}
                      // className="form-file-input form-control"
                    />
                  </label>
                </div>
              </div>
            </form>
          </div>
        )}
        <div>
          {/* <Link to={`/Campaign`}> */}
          <Button
            variant="contained"
            style={{ marginLeft: "85%" }}
            size="medium"
            onClick={() => {
             
              props.submit_campaign_creation();
            }}
          >
            Submit
          </Button>
          {/* </Link>{" "} */}
        </div>
      </div>
    </div>
  );
};
export default StepFour;
